/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PriceValueResponse } from './';
import {
    PriceValueResponseFromJSON,
    PriceValueResponseFromJSONTyped,
    PriceValueResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface PriceResponse
 */
export interface PriceResponse {
    /**
     * 
     * @type {string}
     * @memberof PriceResponse
     */
    visibility: PriceResponseVisibilityEnum;
    /**
     * 
     * @type {PriceValueResponse}
     * @memberof PriceResponse
     */
    value?: PriceValueResponse;
}


/**
 * @export
 */
export const PriceResponseVisibilityEnum = {
    OnDemand: 'ON_DEMAND',
    Visible: 'VISIBLE'
} as const;
export type PriceResponseVisibilityEnum = typeof PriceResponseVisibilityEnum[keyof typeof PriceResponseVisibilityEnum];


/**
 * Check if a given object implements the PriceResponse interface.
 */
export function instanceOfPriceResponse(value: object): value is PriceResponse {
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    return true;
}

export function PriceResponseFromJSON(json: any): PriceResponse {
    return PriceResponseFromJSONTyped(json, false);
}

export function PriceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'visibility': json['visibility'],
        'value': json['value'] == null ? undefined : PriceValueResponseFromJSON(json['value']),
    };
}

export function PriceResponseToJSON(value?: PriceResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'visibility': value['visibility'],
        'value': PriceValueResponseToJSON(value['value']),
    };
}

